import script from "./AtomAvatarOverlay.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomAvatarOverlay.vue?vue&type=script&lang=ts&setup=true"

import "./AtomAvatarOverlay.vue?vue&type=style&index=0&id=ac24c0da&setup=true&lang=css"

const __exports__ = script;

export default __exports__